import { gql } from "generated-graphql";

gql(`
fragment PipelineFragment on Pipeline {
    id
    name
    tenantId
    tenant {
      id
      name
    }
    lastRunAt
    inputFiles
    outputFiles
    ingestedAt
    ingestedBy
    ingestionJob {
      id
      status
    }
    createdAt
    createdBy
    updatedAt
    updatedBy
}
`);

export const INGEST_WASTE_PIPELINE_DATA_MUTATION = gql(`
  mutation IngestWastePipelineData($pipelineId: ID!) {
    ingestWastePipelineData(pipelineId: $pipelineId) {
      id
      status
      task
    }
  }
`);

export const STAFF_PIPELINES_TABLE_QUERY = gql(`
    query StaffPipelinesTable($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
      pipelines(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
        items {
          ...PipelineFragment
        }
        count
      }
    }
  `);

export const WASTE_PIPELINE_RUN_METADATA_QUERY = gql(`
  query WastePipelineRunMetadata($pipelineId: ID!) {
    wastePipelineRunMetadata(pipelineId: $pipelineId) {
      pipelineName
      runKey
      generatedAt
      vendorSource
      sourceRows
      totalRows
      matchedRows
      rejectedRowCount
      notificationRowCount
      pendingReprocessRowCount
      uniqueManifests
      uniqueFacilities
      classificationRcraHazardous
      classificationRcraAcutelyHazardous
      classificationStateRegulated
      classificationNonhazardous
      reportable
      notReportable
    }
    pipeline(id: $pipelineId) {
      ...PipelineFragment
    }
  }
`);

export const WASTE_PIPELINE_RUN_ROWS_QUERY = gql(`
  query WastePipelineRunRows(
    $pipelineId: ID!
    $page: Int
    $pageSize: Int
    $search: String
    $sort: [SortModel!]
  ) {
    wastePipelineRunRows(
      pipelineId: $pipelineId
      page: $page
      pageSize: $pageSize
      search: $search
      sort: $sort
    ) {
      items {
        id
        manifestTrackingNumber
        shippedDate
        receivedDate
        facilityId
        generatorId
        generatorName
        generatorLocationStreetNo
        generatorLocationStreet1
        generatorLocationStreet2
        generatorLocationCity
        generatorLocationZip
        generatorLocationState
        desFacilityId
        desFacilityName
        vendorSource
        vendorSiteId
        wasteLineNumber
        dotHazardous
        dotIdNumberDescription
        dotPrintedInformation
        nonHazWasteDescription
        containerNumber
        containerTypeCode
        quantity
        qtyUnitOfMeasureCode
        managementMethodCode
        managementMethodDescription
        finalManagementMethodCode
        finalManagementMethodDescription
        brDensity
        brDensityUomCode
        brDensityUomDescription
        brFormCode
        brSourceCode
        epaWaste
        federalWasteCodes
        stateWasteCodes
        vendorProfileNumber
        vendorProfileDescription
        vendorComments
        classification
        facilityMatchMethod
        transporter1Id
        transporter1Name
        transporter1DaysInPossession
        transporter2Id
        transporter2Name
        transporter2DaysInPossession
        transporter3Id
        transporter3Name
        transporter3DaysInPossession
        transporter4Id
        transporter4Name
        transporter4DaysInPossession
        tags
        reportable
        overrideManualEdits
      }
      count
    }
  }
`);

export const WASTE_PIPELINE_RUN_REJECTED_ROWS_QUERY = gql(`
  query WastePipelineRunRejectedRows(
    $pipelineId: ID!
    $rejectionType: PipelineRejectionType
    $skip: Int
    $take: Int
  ) {
    wastePipelineRunRejectedRows(
      pipelineId: $pipelineId
      rejectionType: $rejectionType
      skip: $skip
      take: $take
    ) {
      items {
        id
        rejectionReason
        rejectionCategory
        rejectionType
        sourceFile
        sourceLineNumber
        rawData
        extractedAddress {
          name
          streetAddress
          city
          state
          zip
          epaId
          vendorCode
        }
      }
      count
    }
  }
`);

export const WASTE_PIPELINE_RUN_REJECTED_ROW_GROUPS_QUERY = gql(`
  query WastePipelineRunRejectedRowGroups(
    $pipelineId: ID!
    $rejectionType: PipelineRejectionType
    $page: Int
    $pageSize: Int
    $search: String
    $sort: [SortModel!]
  ) {
    wastePipelineRunRejectedRowGroups(
      pipelineId: $pipelineId
      rejectionType: $rejectionType
      page: $page
      pageSize: $pageSize
      search: $search
      sort: $sort
    ) {
      items {
        rejectionReason
        rejectionType
        rowCount
        resolvedAt
        resolvedFacilityId
        lastReprocessAttemptAt
        sampleExtractedAddress {
          name
          streetAddress
          city
          state
          zip
          epaId
          vendorCode
        }
      }
      count
    }
  }
`);

export const WASTE_PIPELINE_RUN_REJECTED_ROWS_BY_REASON_QUERY = gql(`
  query WastePipelineRunRejectedRowsByReason(
    $pipelineId: ID!
    $rejectionReason: String!
    $rejectionType: PipelineRejectionType
    $page: Int
    $pageSize: Int
    $search: String
    $sort: [SortModel!]
  ) {
    wastePipelineRunRejectedRowsByReason(
      pipelineId: $pipelineId
      rejectionReason: $rejectionReason
      rejectionType: $rejectionType
      page: $page
      pageSize: $pageSize
      search: $search
      sort: $sort
    ) {
      items {
        id
        rejectionReason
        rejectionCategory
        rejectionType
        sourceFile
        sourceLineNumber
        rawData
        extractedAddress {
          name
          streetAddress
          city
          state
          zip
          epaId
          vendorCode
        }
      }
      count
    }
  }
`);

export const UPDATE_PIPELINE_OUTPUT_DATA_MUTATION = gql(`
  mutation UpdatePipelineOutputData($id: ID!, $input: UpdatePipelineOutputDataInput!) {
    updatePipelineOutputData(id: $id, input: $input) {
      id
      tags
      reportable
      overrideManualEdits
    }
  }
`);

export const BULK_UPDATE_PIPELINE_OUTPUT_DATA_MUTATION = gql(`
  mutation BulkUpdatePipelineOutputData($input: BulkUpdatePipelineOutputDataInput!) {
    bulkUpdatePipelineOutputData(input: $input) {
      id
      tags
      reportable
      overrideManualEdits
    }
  }
`);

export const FACILITY_SEARCH_QUERY = gql(`
  query FacilityMatchSearch($search: String, $page: Int, $pageSize: Int) {
    facilities(search: $search, page: $page, pageSize: $pageSize) {
      items {
        id
        name
        streetAddress1
        city
        state
        zip
        customerFacilityId
      }
      count
    }
  }
`);

export const FACILITY_ALTERNATE_IDS_QUERY = gql(`
  query PipelineFacilityAlternateIds($id: ID!) {
    facility(id: $id) {
      id
      isEpaIdLocked
      facilityAlternateIds {
        id
        type
        value
        hasNoId
        expiresAt
      }
    }
  }
`);

export const UPDATE_PIPELINE_FACILITY_ALTERNATE_IDS_MUTATION = gql(`
  mutation UpdatePipelineFacilityAlternateIds($id: ID!, $facility: FacilityInput!) {
    updateFacility(id: $id, facility: $facility) {
      id
      facilityAlternateIds {
        id
        type
        value
        hasNoId
        expiresAt
      }
    }
  }
`);

export const MARK_FACILITY_NOT_FOUND_ROWS_RESOLVED_MUTATION = gql(`
  mutation MarkFacilityNotFoundRowsResolved(
    $pipelineId: ID!
    $rejectionReason: String!
    $resolvedFacilityId: ID
  ) {
    markFacilityNotFoundRowsResolved(
      pipelineId: $pipelineId
      rejectionReason: $rejectionReason
      resolvedFacilityId: $resolvedFacilityId
    )
  }
`);

export const UNMARK_FACILITY_NOT_FOUND_ROWS_RESOLVED_MUTATION = gql(`
  mutation UnmarkFacilityNotFoundRowsResolved(
    $pipelineId: ID!
    $rejectionReason: String!
  ) {
    unmarkFacilityNotFoundRowsResolved(
      pipelineId: $pipelineId
      rejectionReason: $rejectionReason
    )
  }
`);

export const REPROCESS_RESOLVED_PIPELINE_ROWS_MUTATION = gql(`
  mutation ReprocessResolvedPipelineRows($pipelineId: ID!) {
    reprocessResolvedPipelineRows(pipelineId: $pipelineId) {
      id
      status
      task
    }
  }
`);
